import { useState, useRef, useEffect } from 'react';

/**
 * 标签创建器状态管理Hook
 */
export function useLabelState() {
  // 标签基本信息
  const [labelName, setLabelName] = useState('');
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [backgroundColor, setBackgroundColor] = useState('#ffffff');
  const [borderColor, setBorderColor] = useState('#000000');
  
  // 内容项列表
  const [contentItems, setContentItems] = useState([]);
  const [selectedContentId, setSelectedContentId] = useState(null);
  
  // 面板状态
  const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);
  const [showPreview, setShowPreview] = useState(true);
  
  // 移动端
  const [mobileView, setMobileView] = useState('settings');
  
  // 提交状态
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitFeedback, setSubmitFeedback] = useState({ type: '', message: '' });
  
  // 预览refs
  const previewRefs = useRef({});

  // 自动滚动到选中项
  useEffect(() => {
    if (selectedContentId && previewRefs.current[selectedContentId]) {
      previewRefs.current[selectedContentId].scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [selectedContentId]);

  return {
    // 标签信息
    labelName, setLabelName,
    backgroundImage, setBackgroundImage,
    backgroundColor, setBackgroundColor,
    borderColor, setBorderColor,
    
    // 内容管理
    contentItems, setContentItems,
    selectedContentId, setSelectedContentId,
    
    // 面板状态
    isLeftPanelCollapsed, setIsLeftPanelCollapsed,
    showPreview, setShowPreview,
    mobileView, setMobileView,
    
    // 提交状态
    isSubmitting, setIsSubmitting,
    submitFeedback, setSubmitFeedback,
    
    // Refs
    previewRefs,
  };
}

